import { render, staticRenderFns } from "./ActiveInfo.vue?vue&type=template&id=3b989962&scoped=true"
import script from "./ActiveInfo.vue?vue&type=script&lang=ts"
export * from "./ActiveInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b989962",
  null
  
)

export default component.exports